import { cloneDeep, omit } from 'lodash-es';

import { request, fetch } from '../utils/request';

const GRAPHICS_BASE = process.env.TAGBOARD_GRAPHICS_URL;

export default {
  async getGraphics(opts = {}) {
    const {
      owner,
      productionId,
      page,
    } = opts;

    const query = { page };

    let url;
    if (productionId) {
      // Fetch by production
      url = `${GRAPHICS_BASE}/graphics/${productionId}`;
      query.owner = owner;
    } else if (owner) {
      // Fetch by owner
      url = `${GRAPHICS_BASE}/graphics/owner/${owner}`;
    } else {
      throw new Error('Must provide either productionId or owner when fetching graphics');
    }

    const data = await fetch(url, { query });

    const graphics = data.results || data.graphics;
    const { total } = data;
    return { graphics, total };
  },

  async getUserTemplates(userId, opts = {}) {
    const {
      page = 1,
      limit = 20,
      tags = [],
    } = opts;

    const querystring = `?page=${page}&limit=${limit}&tags=${encodeURIComponent(tags.join(','))}`;
    const url = `${GRAPHICS_BASE}/templates/${userId}${querystring}`;
    return fetch(url);
  },

  getTemplate(templateId) {
    return request({
      url: `${GRAPHICS_BASE}/template/${templateId}`,
      type: 'GET',
    });
  },

  getTemplates(userId, templateIds = []) {
    return request({
      url: `${GRAPHICS_BASE}/templates/${userId}?templates=${templateIds.join(',')}`,
      type: 'GET',
    });
  },

  createGraphic(obj) {
    return request({
      type: 'POST',
      contentType: 'application/json',
      url: `${GRAPHICS_BASE}/graphic/create`,
      data: JSON.stringify(obj),
    });
  },

  duplicateSavedGraphics(productionId, duplicateId, payload) {
    return request({
      type: 'POST',
      contentType: 'application/json',
      url: `${GRAPHICS_BASE}/graphics/duplicate/${productionId}?duplicateId=${duplicateId}`,
      data: JSON.stringify(payload),
    });
  },

  editGraphic(obj) {
    const id = obj._id;
    const graphic = cloneDeep(omit(obj, ['_id', 'created_time', 'last_updated', 'created_by', 'meta']));

    return request({
      type: 'PUT',
      url: `${GRAPHICS_BASE}/graphic/${id}`,
      contentType: 'application/json',
      data: JSON.stringify(graphic),
    });
  },

  deleteGraphic(obj) {
    const payload = { owner: obj.owner };
    return request({
      type: 'DELETE',
      url: `${GRAPHICS_BASE}/graphic/${obj._id}`,
      contentType: 'application/json',
      data: JSON.stringify(payload),
    });
  },
};
